import { FC } from 'react';
import DateUtils from 'utils/dateUtils';
import { If } from 'components';
import { InvoiceByIdV2 } from '../../invoices.model';

interface InvoiceCustomerSignatureSectionProps {
  invoice: InvoiceByIdV2;
}

const InvoiceCustomerSignatureSection: FC<InvoiceCustomerSignatureSectionProps> = ({ invoice }) => {
  return (
    <div className="rounded-md bg-white shadow-section">
      <div id="invoice-panel-customer-signature" className="px-5 py-3 text-17px font-bold text-headingGray">
        Customer signature
      </div>
      <div className="px-5 pt-2 pb-4">
        <div className="flex justify-between gap-1 text-sbase font-medium text-primaryText">
          <div id="invoice-panel-customer-sign-status" className="font-bold ">
            Status
          </div>
          <If condition={invoice.isInvoiceSigned}>
            <div>Signed</div>
          </If>
          <If condition={!invoice.isInvoiceSigned}>
            <div>Pending</div>
          </If>
        </div>
        <If condition={invoice.isInvoiceSigned}>
          <div className="mt-2 flex items-center justify-end text-[13px] text-accentText">
            <span id="invoice-panel-customer-signature-cust-name">{invoice.signatureCustomerName}</span>
            <If condition={Boolean(invoice?.signedAt)}>
              <span className="mx-1.5 text-xs text-[#BDBDBD]">•</span>
              <span id="invoice-panel-customer-signature-date">
                {invoice?.signedAt &&
                  DateUtils.getDateInFormatwithTimezone({
                    date: DateUtils.parseISODateString(invoice.signedAt),
                    dateFormat: 'dd MMM yyyy'
                  })}
              </span>
            </If>
          </div>
        </If>
      </div>
    </div>
  );
};

export default InvoiceCustomerSignatureSection;
